import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//

import RecurringReminders from "./recurring-reminders";
import Err from "@Broker/@Routes/error";
import { UPDATE_ACCOUNT_PREFERENCES } from "@Broker/@Modules/main/store/account/account-actions";
import { mapActions, mapGetters } from "vuex";
import { showToast } from "@Shared/utils/constants";
import { CURRENT_ACCOUNT_PREFERENCES, APPLICATION_NOTIFICATION_FREQUENCY } from "@Broker/@Modules/main/store/account/account-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "RecurringRemindersContainer",
  components: {
    RecurringReminders
  },
  props: {
    saving: {
      type: Boolean,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters("AccountStore", [CURRENT_ACCOUNT_PREFERENCES, APPLICATION_NOTIFICATION_FREQUENCY])),
  watch: {
    saving(value) {
      if (!value) return;
      this.$refs.recurringReminders.handleSubmit();
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("AccountStore", [UPDATE_ACCOUNT_PREFERENCES])), {}, {
    handleAllowSave(allowSave) {
      this.$emit("allow-save", allowSave);
    },
    async handleSubmit(recurringDays) {
      try {
        let frequency = _parseInt(recurringDays);
        if (!frequency) frequency = null;
        const data = _objectSpread(_objectSpread({}, this.CURRENT_ACCOUNT_PREFERENCES), {}, {
          applicationNotificationFrequency: frequency
        });
        await this.UPDATE_ACCOUNT_PREFERENCES(data);
        showToast("success", "recurringEmailDaysUpdated");
        this.$emit("finish-saving", true);
      } catch (e) {
        this.$emit("finish-saving", false);
        Err.handle(e);
      }
    }
  })
});